import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { IInquiry } from "src/@types/inquiries";
import { IResponseWithPagination } from "src/@types/api";

export const INQUIRIES_SLICE_NAME = "inquiries";
export const ITEMS_PER_PAGE = 10;

export const getInquiriesAsync = createAsyncThunk(
  `${INQUIRIES_SLICE_NAME}/fetchInquiries`,
  async (filters: string, { rejectWithValue }) => {
    try {
      const filtersQueryStr = filters ? filters : "page=1";

      const { data } = await instance.get<IResponseWithPagination<IInquiry>>(
        `/inquiries/?${filtersQueryStr}&page_size=${ITEMS_PER_PAGE}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.inquiries;

      NotificationService.updateToError(errorText);

      return rejectWithValue(errorText);
    }
  }
);

export const getSimilarInquiriesAsync = createAsyncThunk(
  `${INQUIRIES_SLICE_NAME}/fetchSimilarInquiries`,
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IInquiry[]>(
        `/inquiries/${id}/similar/`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.inquiries;

      NotificationService.updateToError(errorText);

      return rejectWithValue(errorText);
    }
  }
);
